import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
.content-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.toast__wrapper {
  font-family: Myriad Pro, sans-serif;
  border-radius: 30px;
  padding: 10px 20px;
}

.toast__wrapper.success {
  background: hsl(185, 81%, 29%);
}

.toast__wrapper.error {
  background: hsl(360, 64%, 55%);
}

.hoverable:hover {
  cursor: pointer;
}

/* fix for fullscreen modal which is positioned on left instead of being centered
 * issue: https://github.com/Semantic-Org/Semantic-UI-React/issues/3345
 */
.ui.fullscreen.modal, .ui.fullscreen.scrolling.modal { 
  left: unset !important;
  margin: unset !important;
}

`;

export default GlobalStyle;
